// src/lib/constants/app.ts

// ── App State Type IDs (as const, NOT TS enum) ──
export const APP_STATE_TYPE_ID = {
  Active: 1,
  Inactive: 2,
  Deleted: 3,
} as const;

// ── App Web Shared Domain IDs (as const, NOT TS enum) ──
export const APP_WEB_SHARED_DOMAIN_ID = {
  VideositeDotApp: 1, // videosite.app (direct customers)
  CloudsiteDotApp: 2, // cloudsite.app (resellers)
  SiteCDNDotApp: 3, // sitecdn.app (reserved)
} as const;

// ── App State Labels ──
export const APP_STATE_LABELS: Record<number, string> = {
  [APP_STATE_TYPE_ID.Active]: 'Active',
  [APP_STATE_TYPE_ID.Inactive]: 'Inactive',
  [APP_STATE_TYPE_ID.Deleted]: 'Deleted',
};

// ── Web Shared Domain Labels ──
export const APP_WEB_DOMAIN_LABELS: Record<number, string> = {
  [APP_WEB_SHARED_DOMAIN_ID.VideositeDotApp]: 'videosite.app',
  [APP_WEB_SHARED_DOMAIN_ID.CloudsiteDotApp]: 'cloudsite.app',
  [APP_WEB_SHARED_DOMAIN_ID.SiteCDNDotApp]: 'sitecdn.app',
};

// ── Spotlight Options ──
export const SPOTLIGHT_OPTIONS = {
  RANDOM_ANY: 'null', // null on API = random from any category
  DISABLED: 'none', // "none" string on API = disabled
} as const;

// ── Constraints ──
export const APP_CONSTRAINTS = {
  NAME_MIN: 1,
  NAME_MAX: 150,
  DESC_MAX: 500,
  WEBSITE_MAX: 250,
  CUSTOM_NAME_MIN: 2,
  CUSTOM_NAME_MAX: 63,
  CUSTOM_DOMAIN_MAX: 253,
  FB_ID_MAX: 65,
  IG_ID_MAX: 40,
  X_ID_MAX: 25,
  YT_ID_MAX: 40,
  GA_ID_MAX: 20,
} as const;

// ── Validation Patterns ──
export const APP_VALIDATION_PATTERNS = {
  FB_ID: /^[a-zA-Z0-9.]{1,65}$/,
  IG_ID: /^[a-zA-Z0-9._]{1,40}$/,
  X_ID: /^[a-zA-Z0-9_]{1,25}$/,
  YT_ID: /^(@[a-zA-Z0-9._-]{1,40}|UC[a-zA-Z0-9_-]{22})$/,
  GA_ID: /^(UA-\d{4,10}-\d{1,4}|G-[A-Z0-9]{4,15})$/i,
  CUSTOM_NAME: /^[a-z0-9]([a-z0-9]*(-[a-z0-9]+)*)?$/,
} as const;

// ── Query Keys ──
export const APP_QUERY_KEYS = {
  all: ['apps'] as const,
  list: (cId: number) => [...APP_QUERY_KEYS.all, 'list', cId] as const,
  detail: (cId: number, appCfgId: number) =>
    [...APP_QUERY_KEYS.all, 'detail', cId, appCfgId] as const,
  customNameCheck: (cId: number, name: string) =>
    [...APP_QUERY_KEYS.all, 'customNameCheck', cId, name] as const,
} as const;
